exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aktarim-sekmesi .v-input--selection-controls{white-space:normal}", ""]);

// exports
